// extracted by mini-css-extract-plugin
module.exports = {"contentBlock":"contact-module--contentBlock--2HnPl","formWrapper":"contact-module--formWrapper--UJKLj"};